<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg6 md6 sm12>
                    <h-currency-input v-model="configuration.Currency" :decimal="0" label="Tỷ giá" class="input-group--focused"></h-currency-input>
                </v-flex>
                <!-- <v-flex lg6 md6 sm12>
                    <h-currency-input v-model="configuration.ExchangeRevenue" :decimal="0" label="Lãi tỷ giá" class="input-group--focused"></h-currency-input>
                </v-flex>  -->
                <!-- <v-flex lg6 md6 sm12>
                    <h-currency-input v-model="configuration.TransportPrice" :decimal="0" label="Giá cân nặng" class="input-group--focused"></h-currency-input>
                </v-flex> -->
                <v-flex lg6 md6 sm12>
                    <h-currency-input v-model="configuration.MinFeeBuy" :decimal="0" label="Phí mua tối thiểu" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-text-field type="number" v-model="configuration.OrderCompleteDate" label="Số ngày tự động hoàn thành đơn" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <h-currency-input :decimal="0" v-model="configuration.Density" label="Tỷ trọng cân nặng" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="configuration.ChinaStoreAddress" label="Địa chỉ kho Trung Quốc" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-icon medium class="mr-2" color="gray darken-3" @click="openExcelEditor(0)">fa-external-link-alt</v-icon>
                    <v-textarea rows="3" v-model="configuration.ReExBanks" label="Danh sách STK" class="input-group--focused" readonly></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-icon medium class="mr-2" color="gray darken-3" @click="openExcelEditor(1)">fa-external-link-alt</v-icon>
                    <v-textarea rows="3" v-model="configuration.ReExMethods" label="Hình thức chi" class="input-group--focused" readonly></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-icon medium class="mr-2" color="gray darken-3" @click="openExcelEditor(2)">fa-external-link-alt</v-icon>
                    <v-textarea rows="3" v-model="configuration.ReExFeeTypes" label="Loại phí RMB" class="input-group--focused" readonly></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-icon medium class="mr-2" color="gray darken-3" @click="openExcelEditor(3)">fa-external-link-alt</v-icon>
                    <v-textarea rows="3" v-model="configuration.ReExFeeTypeVNDs" label="Loại phí VND" class="input-group--focused" readonly></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-icon medium class="mr-2" color="gray darken-3" @click="openExcelEditor(4)">fa-external-link-alt</v-icon>
                    <v-textarea rows="3" v-model="configuration.ProductTypes" label="Loại phí VND" class="input-group--focused" readonly></v-textarea>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
    <oee-excel-editor v-model="excel_editor_data" title="Chỉnh sửa dữ liệu" editor_width="660px" :columns="excel_columns" :dialog="excel_editor_dialog" @closePopup="excel_editor_dialog = false" @change="onExcelEditorUpdate($event)"></oee-excel-editor>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
import excel_editor from "@/components/popups/excel_editor"
export default {
    components: {
        'oee-excel-editor': excel_editor
    },
    data() {
        return {
            excel_data_type: 0,
            excel_editor_dialog: false,
            excel_editor_data: null,
            excel_columns: [
            {
                    'name': 'value',
                    'width': '80px',
                    'label': 'ID',
                    'key_field': true,
                    'type': 'number'
                },
                {
                    'name': 'name',
                    'width': '220px',
                    'label': 'Tên',
                    'key_field': false,
                    'type': 'string'
                },
                {
                    'name': 'desc',
                    'width': '300px',
                    'label': 'Mô tả',
                    'key_field': false,
                    'type': 'string'
                }
            ]
        }
    },
    computed: {
        ...mapState({
            loading: state => state.configuration.loading,
            configuration: state => state.configuration.selected
        })
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
        },
        saveData() {
            this.$store.dispatch("configuration/setDetail", {
                data: this.configuration,
                id: this.configuration.ID
            });
        },
        openExcelEditor(type) {
            this.excel_data_type = type;
            if (this.excel_data_type == 0) {
                this.excel_editor_data = this.configuration.ReExBanks;
            }
            else if (this.excel_data_type == 1) {
                this.excel_editor_data = this.configuration.ReExMethods;
            }
            else if (this.excel_data_type == 2) {
                this.excel_editor_data = this.configuration.ReExFeeTypes;
            }
            else if (this.excel_data_type == 3) {
                this.excel_editor_data = this.configuration.ReExFeeTypeVNDs;
            }
            else if (this.excel_data_type == 4) {
                this.excel_editor_data = this.configuration.ProductTypes;
            }
            this.excel_editor_dialog = true;
        },
        onExcelEditorUpdate(event) {
            this.excel_editor_data = event;
            if (this.excel_data_type == 0) {
                this.configuration.ReExBanks = this.excel_editor_data;
            }
            else if (this.excel_data_type == 1) {
                this.configuration.ReExMethods = this.excel_editor_data;
            }
            else if (this.excel_data_type == 2) {
                this.configuration.ReExFeeTypes = this.excel_editor_data;
            }
            else if (this.excel_data_type == 3) {
                this.configuration.ReExFeeTypeVNDs = this.excel_editor_data;
            }
            else if (this.excel_data_type == 4) {
                this.configuration.ProductTypes = this.excel_editor_data;
            }
        }
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.configuration.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
